import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";
import {
  AdminDashboardApp,
  parseAdminDashboardBootstrapInput,
  type AdminDashboardAppProps,
} from "./app";

const mountedRoots = new WeakMap<HTMLElement, Root>();

declare global {
  interface Window {
    __PETLOG_ADMIN_DASHBOARD_BOOTSTRAP__?: unknown;
  }
}

function readBootstrapOptions(): AdminDashboardAppProps | undefined {
  return parseAdminDashboardBootstrapInput(window.__PETLOG_ADMIN_DASHBOARD_BOOTSTRAP__);
}

export function mountAdminDashboard(root: HTMLElement, options?: AdminDashboardAppProps): void {
  const existingRoot = mountedRoots.get(root);
  const reactRoot = existingRoot ?? createRoot(root);

  if (!existingRoot) {
    mountedRoots.set(root, reactRoot);
  }

  reactRoot.render(
    <StrictMode>
      <AdminDashboardApp {...options} />
    </StrictMode>,
  );
}

const container = document.getElementById("root");

if (container instanceof HTMLElement) {
  mountAdminDashboard(container, readBootstrapOptions());
}
